import { ActivityChangeOptions } from '@spotify/plugin-confidence-activity-react';
import { createFlagUpdatesChangeExtension } from '@spotify/plugin-confidence-flags-react';
import {
  AudienceSegmentRender,
  SegmentData,
} from '@spotify/plugin-confidence-workflows-react';

// Wrap targeting or allocation change into SegmentData format
const wrapChangeAsSegmentData = (change: {
  fieldPath?: string;
  oldValue?: unknown;
  newValue?: unknown;
}): { oldValue: SegmentData | null; newValue: SegmentData | null } => {
  if (change.fieldPath === '/targeting') {
    return {
      oldValue: { targeting: change.oldValue as SegmentData['targeting'] },
      newValue: { targeting: change.newValue as SegmentData['targeting'] },
    };
  }

  if (change.fieldPath === '/allocation') {
    return {
      oldValue: { allocation: change.oldValue as SegmentData['allocation'] },
      newValue: { allocation: change.newValue as SegmentData['allocation'] },
    };
  }

  return { oldValue: null, newValue: null };
};

const SegmentTargetingAllocationRender = ({
  change,
  activity,
}: ActivityChangeOptions) => {
  const wrappedChange = wrapChangeAsSegmentData(change);

  // Create a synthetic change object that AudienceSegmentRender expects
  const syntheticChange = {
    ...change,
    oldValue: wrappedChange.oldValue,
    newValue: wrappedChange.newValue,
  };

  return <AudienceSegmentRender change={syntheticChange} activity={activity} />;
};

export const SEGMENT_TARGETING_ALLOCATION_CHANGE_EXTENSION =
  createFlagUpdatesChangeExtension({
    id: 'segment-targeting-allocation-change',
    priority: 1,
    predicate: ({ change }) =>
      change.fieldPath === '/targeting' || change.fieldPath === '/allocation',
    title: change =>
      change.fieldPath === '/allocation'
        ? 'Updated allocation'
        : 'Updated inclusion criteria',
    render: SegmentTargetingAllocationRender,
  });
